module.exports = __webpack_public_path__ + "img/logo-icon-1.4fe5808b.png";